import { atom } from "@reatom/framework";

export const changeUserDataModalAtom = atom(false, "changeUserDataModal");
